import { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ items, index, onClose, onChange }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onChange((index - 1 + items.length) % items.length);
      if (e.key === "ArrowRight") onChange((index + 1) % items.length);
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [index, items.length, onChange, onClose]);

  if (index < 0) return null;
  const item = items[index];

  return (
    <div
      data-testid="lightbox"
      className="fixed inset-0 z-[60] bg-[#050b08]/95 flex items-center justify-center p-4 sm:p-10 backdrop-blur-sm"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        aria-label="Close"
        data-testid="lightbox-close"
        className="absolute top-5 right-5 w-11 h-11 rounded-full bg-[#FAF9F6]/15 hover:bg-[#C5A059] text-[#FAF9F6] hover:text-[#1A362D] flex items-center justify-center transition-colors"
      >
        <X className="w-5 h-5" strokeWidth={1.5} />
      </button>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onChange((index - 1 + items.length) % items.length);
        }}
        aria-label="Previous"
        className="absolute left-3 sm:left-8 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-[#FAF9F6]/15 hover:bg-[#C5A059] text-[#FAF9F6] hover:text-[#1A362D] flex items-center justify-center transition-colors"
      >
        <ChevronLeft className="w-5 h-5" strokeWidth={1.5} />
      </button>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onChange((index + 1) % items.length);
        }}
        aria-label="Next"
        className="absolute right-3 sm:right-8 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-[#FAF9F6]/15 hover:bg-[#C5A059] text-[#FAF9F6] hover:text-[#1A362D] flex items-center justify-center transition-colors"
      >
        <ChevronRight className="w-5 h-5" strokeWidth={1.5} />
      </button>

      <img
        src={item.src}
        alt={item.alt}
        onClick={(e) => e.stopPropagation()}
        className="max-h-[90vh] max-w-[92vw] object-contain"
      />
      <p className="absolute bottom-6 left-1/2 -translate-x-1/2 text-xs uppercase tracking-[0.3em] text-[#C5A059]">
        {item.alt} · {index + 1} / {items.length}
      </p>
    </div>
  );
}
